<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :has-return="true"
          :page="page"
          @onReturn="() => $router.back()"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 discipline-container">
        <div class="row">
          <div class="col-12">
            <SectionTitle
              content="Búsqueda de Disciplinas Reportadas"
              :has-line="true"
            />
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-md-12">
            <div class="p-3 filter-container">
              <ValidationObserver
                ref="formValidator"
                v-slot="{}"
                tag="form"
                class="row pl-3 pr-1"
              >
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-3 py-1">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="AcademicYear"
                        rules="required"
                      >
                        <div class="custom-ddf">
                          <custom-drop-down
                            v-model="selectedAcademicYear"
                            :custom-error-msg="getMessage('18018').name"
                            :error="errors[0]"
                            :fieldkey="'id'"
                            :fieldname="'description'"
                            :options="academicYears"
                            placeholder="Año Académico"
                            @input="onChange('academicYear', $event)"
                          />
                        </div>
                      </ValidationProvider>
                    </div>
                    <div class="col-md-7 py-1">
                      <custom-drop-down
                        v-model="selectedStatus"
                        :fieldkey="'value'"
                        :fieldname="'text'"
                        :options="status"
                        placeholder="Seleccione Estatus"
                        required
                      />
                    </div>
                    <div class="col-md-2 py-1 pl-0">
                      <action-button
                        :disabled="!selectedAcademicYear"
                        text="Buscar"
                        variant="success"
                        class="fr px-4 "
                        @click="search()"
                      />

                      <action-button
                        v-if="!isDirector"
                        :class="{ transparent: !advance }"
                        class="fr mr-2 pl-3"
                        i="fal fa-sliders-v"
                        variant="orange"
                        @click="() => (advance = !advance)"
                      />
                    </div>
                  </div>
                </div>

                <div v-if="advance" class="col-md-12">
                  <div class="row py-3">
                    <div class="col-md-12">
                      <span class="separator">FILTROS</span>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-4 pt-0">
                      <div class="custom-ddf">
                        <custom-drop-down
                          v-model="selectedRegion"
                          :disabled="!selectedAcademicYear || isDirector"
                          :fieldkey="'id'"
                          :fieldname="'name'"
                          :options="regions"
                          placeholder="Región"
                          @input="onChange('region', $event)"
                        />
                      </div>
                    </div>
                    <div class="col-4 pt-0">
                      <div class="custom-ddf">
                        <custom-drop-down
                          v-model="selectedDistrict"
                          :disabled="!selectedRegion || isDirector"
                          :fieldkey="'id'"
                          :fieldname="'name'"
                          :options="districts"
                          placeholder="Distrito"
                          @input="onChange('district', $event)"
                        />
                      </div>
                    </div>
                    <div class="col-4 pt-0">
                      <div class="custom-ddf">
                        <custom-drop-down
                          v-model="selectedSchool"
                          :disabled="!selectedDistrict || isDirector"
                          :fieldkey="'id'"
                          :fieldname="'name'"
                          :options="schools"
                          placeholder="Escuela"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </div>
          </div>
        </div>

        <div class="row pt-3 mb-2">
          <div class="col-12">
            <custom-separator
              text=" Listado de Escuelas Sin Disciplinas Reportadas"
            />
          </div>
        </div>

        <div
          v-if="rows.length == 0"
          class="col-12 p-4 text-center align-items-center no-info mt-4"
        >
          <div class="col-12 d-flex align-items-center justify-content-center">
            <div class="col-1 pr-0 text-right">
              <i class="far fa-folder-open icon no-info-icon" />
            </div>
            <div class="col-3 text-left">
              <span class="no-info-text ">No hay información disponible.</span>
            </div>
          </div>
        </div>

        <div class="row pt-2">
          <div class="col-12">
            <row
              v-for="(item, index) in rows"
              :key="`row-item-${index}`"
              :item="item"
            />
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 pt-0">
            <customPager
              ref="historyPager"
              :per-page="tableConfig.serverParams.perPage"
              :total="tableConfig.totalRecords"
              :page-changed="onPageChange"
              :per-page-changed="onPerPageChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ActionButton } from '@/components/common';
import { SectionTitle } from '@/components/pei/shared';
import CustomDropDown from '@/components/common/CustomDropDown';
import moment from 'moment';
import store from '@/store/index';
import disciplineActionsCode from '@/utils/constants/student/disciplineActionsCode';
import mixAlert from '@/mixin/alert.mixin';
//import alert from "@/mixin/alert.mixin";

import PageHeader from '@/components/common/page/PageHeader';
import CustomSeparator from '@/components/common/CustomSeparator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import Row from './components/Row';

export default {
  name: 'UnreportedDisciplines',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    ActionButton,
    CustomDropDown,
    PageHeader,
    CustomSeparator,
    ValidationProvider,
    ValidationObserver,
    Row,
  },
  created() {
    this.loadAcademicYears();
    this.loadValidationMessages();
    this.isDirector = this.userProfile.role.toLowerCase() == 'director';
  },
  data() {
    return {
      advance: false,
      sie: store.getters['$_student/StudentSie'],
      page: {
        icon: 'fas fa-user-edit',
        title: 'Reportar Sin Disciplinas',
        routes: ['Inicio', 'Estudiante', 'Reportar Sin Disciplinas'],
      },
      code: disciplineActionsCode,
      rows: [],
      tableConfig: {
        totalRecords: 0,
        serverParams: {
          columnFilters: {},
          sort: {
            field: '',
            type: '',
          },
          page: 1,
          perPage: 20,
        },
      },
      discipline: {},
      academicYears: [],
      regions: [],
      districts: [],
      schools: [],
      status: [
        {
          value: 0,
          text: 'Reportadas',
        },
        {
          value: 1,
          text: 'No Reportadas',
        },
      ],
      selectedRegion: null,
      selectedDistrict: null,
      selectedSchool: null,
      selectedAcademicYear: null,
      selectedStatus: null,
      isDirector: false,
    };
  },
  watch: {
    selectedAcademicYear: function(previousValue, newValue) {
      this.onChange('academicYear', newValue);
    },
  },
  methods: {
    loadAcademicYears() {
      this.$ApiGet('api/academicyears/getacademicyearstocurrentyear')
        .then((res) => {
          this.academicYears = res.data;
          this.getCurrentAcademicYear();
        })
        .catch((err) => {
          self.ShowToast('Alerta', err.message, 'error');
        });
    },
    getCurrentAcademicYear() {
      this.$ApiGet('/api/academicyears/current').then((res) => {
        this.selectedAcademicYear = res.data;
      });
    },
    loadRegions() {
      if (this.selectedAcademicYear == null) return;
      this.$ApiGet(
        `api/schools/user/regions?academicyear=${this.selectedAcademicYear.id}`
      ).then((response) => {
        this.regions = response.data;
        if (this.regions.length == 1) {
          this.selectedRegion = this.regions[0];
        }
      });
    },
    loadDistricts(regionId) {
      this.$ApiGet(
        `api/schools/user/districts?regionid=${regionId}&academicyear=${this.selectedAcademicYear.id}`
      ).then((response) => {
        this.districts = response.data;
        if (this.districts.length == 1) {
          this.selectedDistrict = this.districts[0];
        }
      });
    },
    loadSchools(districtId) {
      this.$ApiGet(
        `api/schools/user/schools?districtid=${districtId}&academicyear=${this.selectedAcademicYear.id}`
      ).then((response) => {
        this.schools = response.data;
        if (this.schools.length == 1) {
          this.selectedSchool = this.schools[0];
        }
      });
    },
    search() {
      let regionId = this.selectedRegion ? this.selectedRegion.id : null;
      let districtId = this.selectedDistrict ? this.selectedDistrict.id : null;
      let schoolId = this.selectedSchool ? this.selectedSchool.id : null;
      this.$ApiGet(
        `/api/student/disciplinesummaries?AcademicYearId=${
          this.selectedAcademicYear.id
        }
        ${regionId ? `&RegionId=${regionId}` : ''}
        ${districtId ? `&DistrictId=${districtId}` : ''}
        ${schoolId ? `&SchoolId=${schoolId}` : ''}
        ${
          this.selectedStatus
            ? `&NotReported=${this.selectedStatus.value != 0}`
            : ''
        }
        &PageNumber=${this.tableConfig.serverParams.page}
        &PageSize=${this.tableConfig.serverParams.perPage}`
      )
        .then((res) => {
          this.rows = res.data.data ? res.data.data : [];

          this.tableConfig.totalPages = res.data.pageCount;
          this.tableConfig.totalRecords = res.data.totalItemCount;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    loadValidationMessages() {
      const messageCodes = ['18018'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    getMessage(code) {
      const message = this.validationMessages
        ? this.validationMessages.find((element) => element.id == code)
        : '';

      return message;
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    updateParams(newProps) {
      this.tableConfig.serverParams = Object.assign(
        {},
        this.tableConfig.serverParams,
        newProps
      );
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.search();
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.search();
    },
    onChange(selectedType, selectedValue) {
      if (this.isDirector) {
        this.loadRegions();
        this.loadDistricts();
        this.loadSchools();
      } else {
        if (selectedType === 'academicYear') {
          this.selectedRegion = null;
          this.selectedDistrict = null;
          this.selectedSchool = null;

          this.regions = [];
          this.districts = [];
          this.schools = [];

          this.loadRegions();
        }

        if (selectedType === 'region') {
          this.selectedDistrict = null;
          this.selectedSchool = null;

          this.districts = [];
          this.schools = [];

          this.loadDistricts(selectedValue.id);
        } else if (selectedType === 'district') {
          this.selectedSchool = null;

          this.schools = [];
          this.loadSchools(selectedValue.id);
        }
      }
    },
    canUseFilters() {
      return !this.isDirector;
    },
  },
};
</script>

<style scoped>
.filter-container {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}
.custom-ddf :placeholder-shown,
.custom-ddf .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}

.card-header .accordion-header .header-title {
  margin-left: 0 !important;
}
.discipline-container {
  font-weight: 400;
}
.accordion {
  background-color: #fafbfa;
}

.accordion >>> hr {
  margin-left: 45px;
  margin-right: 45px;
  border: 1px solid #dadada;
}

.accordion >>> .card-header {
  border-bottom-color: #fafbfa;
}
.accordion >>> .accordion-header[aria-expanded='false'] {
  background-color: #fafbfa;
}

.accordion >>> .accordion-header[aria-expanded='true'] {
  background-color: #fafbfa;
}

.header {
  height: 54px;
  padding-left: 20px;
  background: #3f5b60 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}

.header-description {
  font-weight: bold;
}

.subheader {
  height: 54px;
  padding-left: 20px;
  background: #e7ebe9 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  font-weight: bold;
}

.thead-property {
  color: #ffffff;
}

.tsubhead-property {
  color: #11291b;
  font-weight: bold;
  font-size: 16px;
}

.subheader-footer {
  height: 150px;
  padding-left: 20px;
  background: #fafbfa 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  text-align: center;
}

.subheader-footer .icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 10px;
  padding-left: 3px;
  color: #e2e2e2;
}

.tsubhead-footer {
  color: #727272;
  font-weight: bold;
  font-size: 22px;
  padding-left: 15px;
  padding-bottom: 13px;
  vertical-align: super;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.text-fix {
  font-weight: 400;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 8px;
  padding-right: 4px;
  color: #e2e2e2;
}
</style>
